export enum EDdParameterRuleItemSourceType {
    SQL = 'SQL',
    parameter = 'PARAMETER',
    row = 'ROW',
    filter = 'FILTER'
}

export enum EDdParameterRuleItemType {
    child = 'CHILD',
    parent = 'PARENT'
}
